module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/open/1acdd75fb3ebceaef39da809845e03c3.png";